export const state = {
  searchResults: [],
  muliSearchResults: {}
}